import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import styled from "styled-components";
import axios from "axios";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import BASE_API_URL from "../../api/api";
import apiInstance from "../../Utils/api";

const AddCreditDialog = (props) => {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  const api = apiInstance
  console.log(Math.abs(props.credit), "credit amou");
  console.log(props.id, "sup id");

  const [pay, setPay] = useState("");
  const [isShow, setIsShow] = useState(true);

  const save = () => {
    const data = {
      id: props.id,
      creditAmount: Math.abs(props.credit),
      payAmount: -pay,
    };
    api
      .put("suppliers/pay", data)
      .then(function (response) {
        Swal.fire({
          title: "Successful!",
          text: "You Created Income Data!",
          icon: "success",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
        props.setSupplierForCre([...props.supplierForCre, response.data.data]);
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
    props.close();
  };

  return (
    <div>
      {isShow && (
        <Dialog open={props.open} onClose={props.close}>
          <DialogTitle className="text-center">
            <b>Pay Credit Amount</b>
          </DialogTitle>
          <DialogContent>
            <div className="row form-group">
              <div className="col-12">
                <label htmlFor="">Credit Amount:</label>
                <input
                  type="number"
                  className="form-control"
                  value={Math.abs(props.credit)} //to change from minus to plus
                />
              </div>
              <div className="col-12 mt-2">
                <label htmlFor="">Pay Amount:</label>
                <input
                  type="number"
                  className="form-control"
                  onChange={(e) => setPay(e.target.value)}
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={props.close}>Cancel</Button>
            <Button onClick={save}>Pay</Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
};

export default AddCreditDialog;
